import { useContext, useEffect, useReducer, useRef, useState } from "react";
import ImportEmployeeModal from "./ImportEmployeeModal";
import ChangeStatusModal from "./ChangeStatusModal";
import "./employeesMain.css";
import AddEmployeeModal from "./AddEmployeeModal";
import MainServices from "../../../../services/MainServices";
import TableComponent from "../../../../assets/common/table/TableComponent";
import Pagination from "../../../../assets/common/table/Pagination";
import styles from "../../../../style/cssModules/table/TableComponent.module.css";
import stylesMain from "../../../../style/cssModules/company/Company.module.css";
import actionIcon from "../../../../assets/images/icons/Action.png";
import EmployeeModal from "../employeesNew/EmployeesMain";
import DeleteConfirmationModal from "../table/DeleteModal";
import Tick from "../../../../assets/customIcons/Tick";
import DeleteModal from "../table/DeleteModal";
import ExclaimRed from "../../../../assets/customIcons/ExclaimRed";
import { FaChevronDown } from "react-icons/fa"; // For dropdown icon
import { notifySuccess, notifyWarn } from "../../../../assets/elements/Toast";
import PermissionContextFunctions from "../../../../assets/functions/PermissionContextFunctions";
import totalEmployeesIcon from "../../../../assets/images/icons/Total Employees.svg";
import activeEmployeesIcon from "../../../../assets/images/icons/Active Employees.svg";
import inactiveEmployeesIcon from "../../../../assets/images/icons/Inactive Employees.svg";
import draftEmployesIcon from "../../../../assets/images/icons/draftEmployeesIcon.svg";
import joinedIcon from "../../../../assets/images/icons/joinedIcon.svg";
import underProbationIcon from "../../../../assets/images/icons/underProbationIcon.svg";
import invitedIcon from "../../../../assets/images/icons/invitedIcon.svg";
import pendingInvitationIcon from "../../../../assets/images/icons/pendingInvitation.svg";

// import employeeIcon from "../../../../assets/images/employeesIcons/"
import role_employeeIcon1 from "../../../../assets/images/icons/icons8-male-user-50.png";
import CustomCheckbox from "../table/CustomCheckbox";
import { Dot } from "lucide-react";
import PageLoader from "../../../../assets/loaders/PageLoading";
import { useField } from "formik";
import useConfig from "../../../../hooks/useConfig";
import AsyncSelect from "react-select/async";
import ReactDOM from "react-dom";
import TimingFunctions from "../../../../assets/functions/TimingFunctions";
import HeaderActionItem from "../../../../assets/common/table/HeaderActionItem";
import ActionItem from "../../../../assets/common/table/ActionItem";
import StatusMessages from "../../../../assets/common/table/StatusMessages";
import probationIcon from "../../../../assets/images/icons/Total Employees.svg";
import joinedThisMonthIcon from "../../../../assets/images/icons/Total Employees.svg";
import useAuthContext from "../../../../hooks/useAuthContext";
import AvatarCell from "../common/AvatarCell";
import { getAsyncSelectStyles } from "../../../../utils/asynSelectStyles";
import * as Storage from "../../../../store/LocalStorage";
import useRTLContext from "../../../../hooks/useRTLContext";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { allRoutes } from "../../../../assets/routes/allRoutes";
import {
  DataPercentageCell,
  EmployeeRegistrationSummaryModal,
} from "./DetailsSummaryModal";
import useDepartmentURLSync from "../../../../hooks/useUrlSync";
import useUrlSync from "../../../../hooks/useUrlSync";
import { useSelectSync } from "../../../../hooks/useStateSync";
import { useEnsureOption } from "../../../../hooks/useEnsureOption";
import {
  getEntityByIdOptionWithFormatter,
  getEntityOptionsByFilter,
} from "../../../../utils/getOptions";

const defaultFilters = {
  employeeType: {
    value: ["user", "master", "admin"],
    apiKey: "type",
    operator: "in",
  },
  status: {
    value: ["active", "inactive", "draft"],
    apiKey: "status",
    operator: "in",
  },
};

export default function Employees() {
  const {
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    addedFilters,
    setAddedFilters,
  } = useUrlSync({
    page: 1,
    limit: 10,
    filters: defaultFilters,
  });
  const activeFilter = { key: "status", in: ["active", "inactive"] };
  const [activeStatParam, setActiveStatParam] = useState(null);

  const { userId } = useAuthContext();
  const { isRTL, direction } = useRTLContext();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [importEmployeeModal, setImportEmployeeModal] = useState(false);
  const [statusChangeModal, setStatusChangeModal] = useState(false);
  const [addEmployeeModal, setAddEmployeeModal] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(null);
  const [columns, setColumns] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [changeStatusTitleData, setChangeStatusTitleData] = useState("");
  const [changeStatusMsgData, setChangeStatusMsgData] = useState("");
  const [confirmTitleData, setConfirmTitleData] = useState("");
  const [confirmMsgData, setConfirmMsgData] = useState("");
  const [detailsSummaryPublicId, setDetailsSummaryPublicId] = useState(false);
  const {
    getEmployeesDataNew,
    getEmployeesMaster,
    getEmployeeRegistration,
    getRecurringInvoices,
    getDesignationMaster,
    getDepartmentMaster,
    deleteEmployeeMaster,
    getRolesMaster,
    getExportEmployeeData,
    getEmployeesStatsData,
    getNewEmployeeCountData,
    bulkStatusUpdate,
    sendInvitation,
    getDepartmentById,
    getDesignationById,
    getRoleById,
  } = MainServices();
  const config = useConfig();
  const [canAccessEmployeeKey, setCanAccessEmployeeKey] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [statusDropdown, setStatusDropdown] = useState(false);
  const [isUserInvitedFilter, setIsUserInvitedFilter] = useState(false);
  const [isUserPendingInvitationFilter, setIsUserPendingInvitationFilter] =
    useState(false);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [onSubmit, setOnSubmit] = useState(false);
  const [onDraft, setOnDraft] = useState(false);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [statusOptions, setStatusOptions] = useState([
    { value: "active", label: t("Active") },
    { value: "inactive", label: t("Inactive") },
    { value: "draft", label: t("Draft") },
  ]);
  const hasFetched = useRef(false); // Track if API is called
  const [empPublicId, setEmpPublicId] = useState("");
  const [deactivateEmployeeData, setDeactivateEmployeeData] = useState("");
  const [editData, setEditData] = useState("");
  const [singleEmployeeRegistrationData, setSingleEmployeeRegistrationData] =
    useState("");
  const [designationOptions, setDesignationOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [isFinalModal, setIsFinalModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { grantPermission } = PermissionContextFunctions();
  const [draftCount, setDraftCount] = useState(0);
  const [viewDraftData, setViewDraftData] = useState(false);
  const [allEmpCount, setAllEmpCount] = useState(0);
  const [reactivateModal, setReactivateModal] = useState(false);
  const [reactivateFinal, setREactivateFinal] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");
  const dropdownRef = useRef(null);
  const threeDotsRef = useRef(null);
  const [exportLoading, setExportLoading] = useState(false);

  const [bulkStatus, setBulkStatus] = useState("");
  const [bulkUpdate, setBulkUpdate] = useState(false);
  const [changeStatusBtn, setChangeStatusBtn] = useState("");
  const [changeStatusTitle, setChangeStatusTitle] = useState("");
  const [changeStatusMsg, setChangeStatusMsg] = useState("");
  const [confirmTitle, setConfirmTitle] = useState("");
  const [confirmMsg, setConfirmMsg] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [noData, setNoData] = useState(false);
  const [submitTitle, setSubmitTitle] = useState("");
  const [submitMsg, setSubmitMsg] = useState("");
  const [submitBtn, setSubmitBtn] = useState("");
  const [submitConfirmTitle, setSubmitConfirmTitle] = useState("");
  const [submitConfirmMsg, setSubmitConfirmMsg] = useState("");
  const [submitConfirmBtn, setSubmitConfirmBtn] = useState("");
  const [empDetailsSummaryModal, setEmpDetailsSummaryModal] = useState(false);

  const [additionalStats, setAdditionalStats] = useState([
    {
      name: t("Total Employees"),
      count: 0,
      icon: totalEmployeesIcon,
      iconAlt: "Total Employees Icon",
      param: "totalEmployees",
    },
    {
      name: t("Active Employees"),
      count: 0,
      icon: activeEmployeesIcon,
      iconAlt: "Active Employees Icon",
      param: "activeEmployees",
    },
    {
      name: t("Inactive Employees"),
      count: 0,
      icon: inactiveEmployeesIcon,
      iconAlt: "Inactive Employees Icon",
      param: "inactiveEmployees",
    },
    {
      name: t("Drafted Employees"),
      count: 0,
      icon: draftEmployesIcon,
      iconAlt: "Drafted Employees Icon",
      param: "draftedEmployees",
    },
    {
      name: t("Joined This Month"),
      count: 0,
      icon: joinedIcon,
      iconAlt: "Joined This Month Icon",
      param: "newEmployee",
    },
    {
      name: t("Under Probation"),
      count: 0,
      icon: underProbationIcon,
      iconAlt: "Under Probation Icon",
      param: "probation",
    },
    {
      name: t("Invited Employees"),
      count: 0,
      icon: invitedIcon,
      iconAlt: "Invited User Icon",
      param: "userInvitation",
    },
    {
      name: t("Pending Invitation"),
      count: 0,
      icon: pendingInvitationIcon,
      iconAlt: "Not Invited User Icon",
      param: "userPendingsInvitation",
    },
  ]);
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [isProbationFilter, setIsProbationFilter] = useState(false);
  const [isNewEmployeeFilter, setIsNewEmployeeFilter] = useState(false);
  const [isTotalFilter, setIsTotalFilter] = useState(false);
  const [isActiveFilter, setIsActiveFilter] = useState(false);
  const [isInactiveFilter, setIsInactiveFilter] = useState(false);
  const [isDraftedFilter, setIsDraftedFilter] = useState(false);

  const getTranslationKey = (param) => {
    const map = {
      totalEmployees: "Total Employees",
      activeEmployees: "Active Employees",
      inactiveEmployees: "Inactive Employees",
      draftedEmployees: "Drafted Employees",
      newEmployee: "Joined This Month",
      probation: "Under Probation",
      userInvitation: "Invited Employees",
      userPendingsInvitation: "Pending Invitation",
    };

    return map[param] || param;
  };

  const defaultStatusArray = ["active", "inactive", "draft"];

  useSelectSync({
    filterKey: "status",
    options: statusOptions,
    addedFilters,
    setSelected: setSelectedStatus,
    selected: selectedStatus, // ← pass it here
    getFilterValue: (f) => {
      if (!f) return null;
      if (
        Array.isArray(f.value) &&
        defaultStatusArray.every((v) => f.value.includes(v))
      )
        return null; // treat default array as “no filter”
      return f.value; // either "active" or "inactive"
    },
  });

  useSelectSync({
    filterKey: "desigId",
    options: designationOptions, // async‑loaded list
    addedFilters,
    setSelected: setSelectedDesignation,
  });

  // 2️⃣  Role          (filter key: roleId)
  useSelectSync({
    filterKey: "roleId",
    options: roleOptions,
    addedFilters,
    setSelected: setSelectedRole,
  });

  // 3️⃣  Department    (filter key: deptId)
  useSelectSync({
    filterKey: "deptId",
    options: departmentOptions,
    addedFilters,
    setSelected: setSelectedDepartment,
  });

  useEffect(() => {
    // Update selected status label when language changes
    if (selectedStatus?.value) {
      const translatedOptions = [
        { value: "active", label: t("Active") },
        { value: "inactive", label: t("Inactive") },
        { value: "draft", label: t("Draft") },
      ];

      const updatedOption = translatedOptions.find(
        (option) => option.value === selectedStatus.value
      );

      if (updatedOption) {
        setSelectedStatus(updatedOption);
      }
    }
  }, [i18n.language]); // Only depend on language change

  useEffect(() => {
    const employeeAccess = grantPermission([`Employee:read`]);
    const isAccess = Storage.get(config?.canAccessEmployeeKey);
    if (!employeeAccess) {
      navigate(config?.myProfile);
    }
  }, [Storage.get(config?.canAccessEmployeeKey)]);

  useEffect(() => {
    setAdditionalStats((prevStats) =>
      prevStats.map((item) => ({
        ...item,
        name: t(getTranslationKey(item.param)),
      }))
    );
  }, [direction]);

  const { deBounce } = TimingFunctions();
  console.log("addedfilters: ", addedFilters);

  useEffect(() => {
    setColumns(getItemsColumns());
  }, [
    openMenu,
    statusDropdown,
    designationOptions,
    roleOptions,
    departmentOptions,
    data,
    selectedDesignation,
    isRTL,
    selectedStatus,
  ]);

  useEffect(() => {
    getDepartmentOptions();
    getDesignationOptions();
    getNewEmployeeCount();
    getRoleOptions();
    getItemsMaster();
  }, []);

  useEffect(() => {
    getItemsMaster();
  }, [currentPage, addedFilters, itemsPerPage]);

  useEffect(() => {
    const statsParam = addedFilters?.statsFilter?.value;

    // Or infer it from other filters if needed
    const status = addedFilters?.status?.value;
    const userInvitation = addedFilters?.userInvitation?.value;

    if (statsParam) {
      setActiveStatParam(statsParam);
    } else if (userInvitation === "true") {
      setActiveStatParam("userInvitation");
    } else if (userInvitation === "false") {
      setActiveStatParam("userPendingsInvitation");
    } else if (
      Array.isArray(status) &&
      status.includes("draft") &&
      status.length === 3
    ) {
      setActiveStatParam("totalEmployees");
    } else if (status === "active") {
      setActiveStatParam("activeEmployees");
    } else if (status === "inactive") {
      setActiveStatParam("inactiveEmployees");
    } else if (status === "draft") {
      setActiveStatParam("draftedEmployees");
    } else {
      setActiveStatParam(null); // No specific tile selected
    }
  }, [addedFilters]);

  useEffect(() => {
    setAdditionalStats((prevStats) =>
      prevStats.map((stat) => ({
        ...stat,
        active: stat.param === activeStatParam,
      }))
    );
  }, [activeStatParam]);

  // useEffect(() => {
  //   console.log("changes filter fetcing data: ", statusFilter);
  //   if (statusFilter) {
  //     getItemsMaster();
  //   }
  // }, [statusFilter]);

  const getNewEmployeeCount = async () => {
    const details = {
      filters: [
        {
          key: "status",
          in: ["active", "draft", "inactive"],
        },
      ],
    };

    const statsDetails = {
      filters: [
        {
          key: "type",
          in: ["user", "master", "admin"],
        },
      ],
    };

    try {
      const [responseAdditionalStats, responseStats] = await Promise.all([
        getNewEmployeeCountData(details),
        getEmployeesStatsData(statsDetails),
      ]);

      const stats = responseStats?.data?.data;

      const { active = 0, inactive = 0, draft = 0 } = stats;

      const joinedCount =
        responseAdditionalStats?.data?.data?.data?.newEmployeeCount || 0;
      const probationCount =
        responseAdditionalStats?.data?.data?.data?.probationCount || 0;
      const totalInvited =
        responseAdditionalStats?.data?.data?.data?.invitedCount || 0;
      const totalNotInvited =
        responseAdditionalStats?.data?.data?.data?.notInvitedCount || 0;

      const total = active + inactive + draft + probationCount;
      setDraftCount(draft);
      setAllEmpCount(total);
      if (viewDraftData) {
        setTotalCount(draft);
      } else {
        setTotalCount(total);
      }

      setAdditionalStats((prevStats) =>
        prevStats.map((stat) => {
          switch (stat.param) {
            case "newEmployee":
              return { ...stat, count: joinedCount };
            case "probation":
              return { ...stat, count: probationCount };
            case "userInvitation":
              return { ...stat, count: totalInvited };
            case "userPendingsInvitation":
              return { ...stat, count: totalNotInvited };
            case "totalEmployees":
              return { ...stat, count: total };
            case "activeEmployees":
              return { ...stat, count: active };
            case "inactiveEmployees":
              return { ...stat, count: inactive };
            case "draftedEmployees":
              return { ...stat, count: draft };
            default:
              return stat;
          }
        })
      );
    } catch (error) {
      console.error("Error fetching new employee stats:", error);
    }
  };

  const getUnderProbationCount = async () => {
    const details = {
      field: "probation",
    };
    try {
      const response = await getNewEmployeeCountData(details);
      if (response?.data) {
        const data = response?.data?.data?.total_count;
      }
    } catch (error) {
      console.error("Error", error);
    }
  };
  const handleAdditionalStatsClick = (param) => {
    const isSame = activeStatParam === param;

    removeAllFilters(); // Always reset
    setActiveStatParam(isSame ? null : param); // Deselect if clicked again

    // Set filters depending on which tile was clicked
    switch (param) {
      case "newEmployee":
      case "probation":
        addFilter(
          "status",
          ["active", "inactive", "draft"],
          "status",
          false,
          "in"
        );
        if (!isSame) addFilter("statsFilter", param, "statsFilter", true);
        break;

      case "userInvitation":
        addFilter(
          "status",
          ["active", "inactive", "draft"],
          "status",
          false,
          "in"
        );
        if (!isSame)
          addFilter("userInvitation", "true", "userInvitation", false);
        break;

      case "userPendingsInvitation":
        addFilter(
          "status",
          ["active", "inactive", "draft"],
          "status",
          false,
          "in"
        );
        if (!isSame)
          addFilter("userInvitation", "false", "userInvitation", false);
        break;

      case "totalEmployees":
        addFilter(
          "status",
          ["active", "inactive", "draft"],
          "status",
          false,
          "in"
        );
        break;

      case "activeEmployees":
      case "inactiveEmployees":
      case "draftedEmployees":
        const singleStatus = {
          activeEmployees: "active",
          inactiveEmployees: "inactive",
          draftedEmployees: "draft",
        }[param];
        addFilter(
          "status",
          isSame ? ["active", "inactive"] : singleStatus,
          "status",
          false,
          isSame ? "in" : "eq"
        );
        if (!isSame)
          addFilter("excludeProbation", "true", "excludeProbation", true);
        break;

      default:
        break;
    }
  };

  const getDesignationOptions = async (filters = [], search) => {
    const mergedFilters = [
      activeFilter,
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      filters: mergedFilters,
    };
    try {
      const response = await getDesignationMaster(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options = [
          ...(response?.data?.data?.doc?.map((designation) => ({
            label: designation.name,
            value: designation.publicId,
          })) || []), // Fallback for undefined/null
        ];
        !search && setDesignationOptions(options);
        return options;
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSearchDesignationDebounce = (inputValue, callback) => {
    deBounce(() => onSearchdDesignation(inputValue, callback), 1000);
  };

  const onSearchdDesignation = async (inputValue, callback) => {
    if (!inputValue) {
      callback(designationOptions);
      return;
    }

    let filter = [
      {
        key: "name",
        iLike: inputValue,
      },
    ];
    let options = await getDesignationOptions(filter, true);
    callback(options);
  };

  const getDepartmentOptions = async (filters = [], search) => {
    const mergedFilters = [
      activeFilter,
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      filters: mergedFilters,
    };
    try {
      const response = await getDepartmentMaster(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options = [
          ...(response?.data?.data?.doc?.map((department) => ({
            label: department.name,
            value: department.publicId,
          })) || []), // Fallback for undefined/null
        ];
        !search && setDepartmentOptions(options);
        return options;
      } else {
        setDepartmentOptions([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSearchDepartmentDebounce = (inputValue, callback) => {
    deBounce(() => onSearchdDepartment(inputValue, callback), 1000);
  };

  const onSearchdDepartment = async (inputValue, callback) => {
    if (!inputValue) {
      callback(departmentOptions);
      return;
    }

    let filter = [
      {
        key: "name",
        iLike: inputValue,
      },
    ];
    let options = await getDepartmentOptions(filter, true);
    callback(options);
  };

  const getRoleOptions = async (filters = [], search) => {
    const mergedFilters = [
      activeFilter,
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      filters: mergedFilters,
    };

    try {
      const response = await getRolesMaster(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options = [
          ...(response?.data?.data?.doc?.map((role) => ({
            label: role.role,
            value: role.publicId,
          })) || []),
        ];
        !search && setRoleOptions(options);
        return options;
      } else {
        setDepartmentOptions([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSearchRoleDebounce = (inputValue, callback) => {
    deBounce(() => onSearchdRole(inputValue, callback), 1000);
  };

  const onSearchdRole = async (inputValue, callback) => {
    if (!inputValue) {
      callback(roleOptions);
      return;
    }

    let filter = [
      {
        key: "role",
        iLike: inputValue,
      },
    ];
    let options = await getRoleOptions(filter, true);
    callback(options);
  };

  const onSearchStatusDebounce = (inputValue, callback) => {
    const filtered = statusOptions.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    callback(filtered);
  };

  const addSearchFilter = (searchValue, fields = []) => {
    if (!searchValue || fields.length === 0) return;

    setCurrentPage(1);
    setAddedFilters((prev) => ({
      ...prev,
      searchString: {
        key: "searchString",
        searchString: searchValue,
        fields: fields,
        isSearchString: true, // flag to identify this type later
      },
    }));
  };

  const addFilter = (
    filterKey,
    value,
    apiKey = filterKey,
    isQueryParam = false,
    operator = "eq" // default to 'eq' if not provided
  ) => {
    setCurrentPage(1);
    setAddedFilters((prev) => ({
      ...prev,
      [filterKey]: { value, apiKey, isQueryParam, operator },
    }));
  };

  const hasFilterWithValue = (filters, key, expectedValue) => {
    const filter = filters[key];
    if (!filter) return false;

    if (expectedValue === undefined) return true;

    // Handle array and single value comparisons
    if (Array.isArray(filter.value)) {
      return filter.value.includes(expectedValue);
    }
    return filter.value === expectedValue;
  };

  // Remove a filter
  const removeFilter = (filterKey) => {
    setAddedFilters((prev) => {
      const newFilters = { ...prev };
      delete newFilters[filterKey];
      return newFilters;
    });
  };

  // Clear all filters (keep defaults if needed)
  const removeAllFilters = () => {
    setSelectedStatus("");
    setSelectedDesignation("");
    setSelectedDepartment("");
    setSelectedRole("");
    setIsProbationFilter(false);
    setIsNewEmployeeFilter(false);
    setIsUserInvitedFilter(false);
    setIsUserPendingInvitationFilter(false);
    setIsInactiveFilter(false);
    setIsActiveFilter(false);
    setIsTotalFilter(false);
    setIsDraftedFilter(false);
    setSearchTerm("");
    setAddedFilters((prev) => {
      const { employeeType } = prev;
      return employeeType ? { employeeType } : {};
    });
  };

  const buildApiFilters = () => {
    const apiFilters = [];
    const queryParams = {};

    Object.values(addedFilters).forEach((filter) => {
      if (
        (filter.value !== null &&
          filter.value !== undefined &&
          filter.value !== "" &&
          !(Array.isArray(filter.value) && filter.value.length === 0)) ||
        filter.isSearchString // allow search string filter even if no `.value`
      ) {
        if (filter.isSearchString && filter.fields?.length) {
          apiFilters.push({
            key: filter.key,
            searchString: filter.searchString,
            fields: filter.fields,
          });
        } else if (filter.isQueryParam) {
          queryParams[filter.apiKey] = filter.value;
        } else {
          const operator = filter.operator || "eq";
          apiFilters.push({
            key: filter.apiKey,
            [operator]: filter.value,
          });
        }
      }
    });

    return {
      filters: apiFilters,
      queryParams,
    };
  };

  const getItemsMaster = async () => {
    setIsLoading(true);
    const { filters: apiFilters, queryParams } = buildApiFilters();

    const filters = {
      pageSize: itemsPerPage,
      pageNumber: currentPage,
      sorting: [
        { key: "status", direction: "asc" },
        { key: "createdAt", direction: "desc" },
      ],
      filters: apiFilters,
      ...queryParams,
    };

    try {
      const registrationDataResponse = await getEmployeeRegistration(filters);
      if (registrationDataResponse?.data) {
        const totalRecords =
          registrationDataResponse.headers["x-coreplatform-total-records"] || 0;
        if (!totalRecords) {
          setNoData(true);
        } else {
          setNoData(false);
        }

        const safeTotalRecords = Number(totalRecords) || 0;
        const safeItemsPerPage = Number(itemsPerPage) || 1;

        const totalPages = Math.max(
          1,
          Math.ceil(safeTotalRecords / safeItemsPerPage)
        );
        setTotalPages(totalPages);
        const newData = registrationDataResponse?.data?.data?.doc;
        const updatedNewData = newData.map((row) => ({
          ...row,
          isSelected: false,
        }));
        setData(updatedNewData);
        getNewEmployeeCount();

        setIsLoading(false);
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchTermDebounce = (inputValue) => {
    setSearchTerm(inputValue);
    deBounce(() => handleSearchTermFilter(inputValue), 1000);
  };

  const handleSearchTermFilter = (searchString) => {
    if (searchString) {
      addSearchFilter(searchString, ["firstName", "email", "phone"]);
    } else {
      removeFilter("searchString");
    }
  };

  const handleExportClick = async () => {
    const selectedRows = data.filter((row) => row.isSelected);

    const publicIds = selectedRows.map((row) => row?.personalInfo?.publicId);

    const { filters: apiFilters, queryParams } = buildApiFilters();

    const details = {
      filters: [
        ...apiFilters, // Spread existing API filters
        ...(publicIds?.length
          ? [
              {
                // Only include if publicIds has items
                key: "publicId",
                in: publicIds,
              },
            ]
          : []), // Empty array if no publicIds
      ],
      ...queryParams, // Spread other query parameters
    };

    try {
      setExportLoading(true);
      const response = await getExportEmployeeData(details);
      if (response?.data) {
        const exportFileName = response?.data?.data?.filePath;
        // console.log("exportFileName: ", exportFileName);
        const fileLink = `${config?.exportLink}${exportFileName}`;

        // Create a hidden anchor element
        const link = document.createElement("a");
        link.href = fileLink;
        link.download = exportFileName; // Set the file name for the download
        document.body.appendChild(link); // Append to the DOM (required for Firefox)
        link.click(); // Programmatically click the link to trigger the download
        document.body.removeChild(link); // Clean up by removing the link from the DOM

        notifySuccess(t("Data Exported Successfully"));
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error creating designation", error);
    } finally {
      setExportLoading(false);
    }
  };

  const deactivateEmployeeMaster = async () => {
    let empStatus;
    if (isDelete) {
      empStatus = "delete";
    } else if (deactivateEmployeeData?.status === "inactive") {
      empStatus = "active";
    } else if (deactivateEmployeeData?.status === "active") {
      empStatus = "inactive";
    } else if (deactivateEmployeeData?.status === "draft") {
      empStatus = "delete";
    }

    const details = {
      status: empStatus,
    };

    try {
      const deleteResponse = await deleteEmployeeMaster(
        details,
        deactivateEmployeeData?.publicId,
        deactivateEmployeeData?.concurrencyStamp
      );

      if (deleteResponse?.data) {
        setDeleteConfirmModal(true);
        setIsDeleteModalOpen(false);
        setDeactivateEmployeeData("");
        getItemsMaster();
        getNewEmployeeCount();
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    } finally {
      setIsDelete(false);
    }
  };

  function selectAllCheckBox() {}

  function handleSelectCheckBox() {}

  function toggleSelectAll() {
    const newAllSelected = !allSelected; // Toggle the "Select All" state
    setAllSelected(newAllSelected);

    const updatedData = data.map((row) => ({
      ...row,
      isSelected: newAllSelected, // Set all rows to selected/deselected
    }));
    setData(updatedData); // Update the table data
  }

  const toggleRowSelection = (rowIndex) => {
    // Update the specific row's isSelected state
    setData((prevData) => {
      const updatedData = prevData.map((row, index) =>
        index === rowIndex ? { ...row, isSelected: !row.isSelected } : row
      );

      // Recalculate the "Select All" state based on updatedData
      const newAllSelected = updatedData.every((row) => row.isSelected);
      setAllSelected(newAllSelected);

      return updatedData;
    });
  };
  const handleSelectFilter = (status, column) => {
    if (!status) {
      setFilteredData(null); // Reset to all data
    } else {
      setStatusFilter(status);

      setCurrentPage(1);
      getItemsMaster(status);
    }
  };

  const loadDesignationOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback(designationOptions);
    } else {
      const filteredOptions = designationOptions.filter((option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    }
  };

  const updateBulkStatus = async () => {
    const selectedRows = data.filter((row) => row.isSelected);

    const publicIds = selectedRows.map((row) => row?.personalInfo?.publicId);

    const details = {
      publicIds,
      moduleName: "User",
      status: bulkStatus === "draft" ? "delete" : bulkStatus,
    };

    try {
      const newResponse = await bulkStatusUpdate(details);
      if (newResponse?.data) {
        setDeleteConfirmModal(true);
        setIsDeleteModalOpen(false);
        setBulkUpdate(false);
        setBulkStatus("");
        getItemsMaster();
        getNewEmployeeCount();
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error creating designation", error);
    }
  };

  const handleBulkStatusUpdate = (status) => {
    setBulkUpdate(true);
    setBulkStatus(status);
    const selectedRows = data.filter((row) => row.isSelected);
    const selectedCount = selectedRows.length;

    const {
      title: changeStatusTitle,
      titleData: changeStatusTitleData,
      message: changeStatusMsg,
      messageData: changeStatusMsgData,
      button: changeStatusBtn,
      confirmTitle,
      confirmTitleData,
      confirmMessage: confirmMsg,
      confirmMessageData: confirmMsgData,
    } = StatusMessages({
      moduleName: "Employee",
      status,
      count: selectedCount,
      i18n: i18n,
    });

    setChangeStatusTitle(changeStatusTitle);
    setChangeStatusMsg(changeStatusMsg);
    setChangeStatusBtn(changeStatusBtn);
    setConfirmTitle(confirmTitle);
    setConfirmMsg(confirmMsg);
    setChangeStatusTitleData(changeStatusTitleData);
    setChangeStatusMsgData(changeStatusMsgData);
    setConfirmTitleData(confirmTitleData);
    setConfirmMsgData(confirmMsgData);

    setIsDeleteModalOpen(true);
  };

  const handleViewDetailsSummary = (personalInfo) => {
    setEmpDetailsSummaryModal(true);
    setDetailsSummaryPublicId(
      personalInfo?.publicId || personalInfo?.public_id
    );
  };

  const getDepartmentWithCodeOption = (id) =>
    getEntityByIdOptionWithFormatter(
      getDepartmentById,
      id,
      (data) => `${data.name})`, // Custom label format
      "publicId"
    );

  const getDesignationWithCodeOption = (id) =>
    getEntityByIdOptionWithFormatter(
      getDesignationById,
      id,
      (data) => `${data.name})`, // Custom label format
      "publicId"
    );

  // User options by role with custom formatting
  const getUserOptionsByRole = (roleId) =>
    getEntityOptionsByFilter(
      getRolesMaster,
      "publicId",
      roleId,
      { labelField: "role", valueField: "publicId" },
      "data.data.doc"
    );

  useEnsureOption({
    filterKey: "deptId",
    addedFilters,
    options: departmentOptions,
    setOptions: setDepartmentOptions,
    setSelected: setSelectedDepartment, // 🔹 pass setter
    fetchByValue: getDepartmentWithCodeOption,
  });

  useEnsureOption({
    filterKey: "desigId",
    addedFilters,
    options: designationOptions,
    setOptions: setDesignationOptions,
    setSelected: setSelectedDesignation, // 🔹 pass setter
    fetchByValue: getDesignationWithCodeOption,
  });

  useEnsureOption({
    filterKey: "roleId",
    addedFilters,
    options: roleOptions,
    setOptions: setRoleOptions,
    setSelected: setSelectedRole, // 🔹 pass setter
    fetchByValue: getUserOptionsByRole,
  });

  const getItemsColumns = () => [
    {
      Header: () => (
        <CustomCheckbox checked={allSelected} onChange={toggleSelectAll} />
      ),
      accessor: "select",
      Cell: ({ row, rowIndex }) => (
        <CustomCheckbox
          checked={row.original.isSelected || false}
          onChange={() => toggleRowSelection(row.index)}
        />
      ),
      style: {
        width: "64px",
        maxWidth: "64px",
        textAlign: "center",
        padding: "10px 12px",
      },
    },
    {
      Header: t("Employee ID"),
      accessor: "employmentInfo.employeeId",
      Cell: ({ value, row, rowIndex }) => (
        <div
          className="cursor-pointer"
          onClick={() => handleViewProfile(row?.original?.personalInfo)}
        >
          {value}
        </div>
      ),
    },
    {
      Header: t("Employee Name"),
      accessor: "personalInfo",
      Cell: ({ value }) => <AvatarCell data={value} />,
    },
    {
      Header: () => (
        <AsyncSelect
          id="designation"
          name="designation"
          value={selectedDesignation}
          onChange={(selectedOption) => {
            setSelectedDesignation(selectedOption);
            if (selectedOption) {
              if (
                !designationOptions.some(
                  (o) => o.value === selectedOption.value
                )
              ) {
                setDesignationOptions((prev) => [...prev, selectedOption]);
              }
              addFilter("desigId", selectedOption?.value, "desigId", true);
            } else if (addedFilters?.hasOwnProperty("desigId")) {
              removeFilter("desigId");
            }
          }}
          loadOptions={onSearchDesignationDebounce}
          defaultOptions={designationOptions}
          styles={getAsyncSelectStyles({
            minWidth: "200px",
            autoWidth: true,
            fitInFlex: true,
          })}
          menuPortalTarget={document.body} // Ensures dropdown renders outside of scrollable parent
          cacheOptions
          isClearable={true}
          placeholder={t("Designation")}
        />
      ),
      accessor: "employmentInfo.designationInfo.name",
      isFiltered: !!selectedDesignation,
      style: {
        width: "100%",
      },
    },
    {
      Header: () => (
        <AsyncSelect
          id="role"
          name="role"
          value={selectedRole}
          onChange={(selectedOption) => {
            setSelectedRole(selectedOption);
            if (selectedOption) {
              if (!roleOptions.some((o) => o.value === selectedOption.value)) {
                setRoleOptions((prev) => [...prev, selectedOption]);
              }
              addFilter("roleId", selectedOption?.value, "roleId", true);
            } else if (addedFilters?.hasOwnProperty("roleId")) {
              removeFilter("roleId");
            }
          }}
          loadOptions={onSearchRoleDebounce}
          defaultOptions={roleOptions}
          styles={getAsyncSelectStyles({
            minWidth: "200px", // customize per usage
            autoWidth: true,
            fitInFlex: true,
          })}
          menuPortalTarget={document.body} // Ensures dropdown renders outside of scrollable parent
          cacheOptions
          isClearable={true}
          placeholder={t("Role")}
        />
      ),
      accessor: "employmentInfo.roleInfo.role",
      isFiltered: !!selectedRole,
      style: {
        width: "100%",
      },
      // Cell: ({ value, row }) => <span>{value?.roleInfo?.role}</span>,
    },
    {
      Header: () => (
        <AsyncSelect
          id="department"
          name="department"
          value={selectedDepartment}
          onChange={(selectedOption) => {
            setSelectedDepartment(selectedOption);
            if (selectedOption) {
              if (
                !departmentOptions.some((o) => o.value === selectedOption.value)
              ) {
                setDepartmentOptions((prev) => [...prev, selectedOption]);
              }
              addFilter("deptId", selectedOption?.value, "deptId", true);
            } else if (addedFilters?.hasOwnProperty("deptId")) {
              removeFilter("deptId");
            }
          }}
          loadOptions={onSearchDepartmentDebounce}
          defaultOptions={departmentOptions}
          styles={getAsyncSelectStyles({
            minWidth: "200px", // customize per usage
            autoWidth: true,
            fitInFlex: true,
          })}
          menuPortalTarget={document.body} // Ensures dropdown renders outside of scrollable parent
          cacheOptions
          isClearable={true}
          placeholder={t("Department")}
        />
      ),
      accessor: "employmentInfo.departmentInfo.name",
      isFiltered: !!selectedDepartment,
      style: {
        width: "100%",
      },
    },
    {
      Header: t("Profile Percentage"),
      accessor: "personalInfo.completionPercentage",
      Cell: ({ value, row, rowIndex }) => (
        <DataPercentageCell
          value={value}
          row={row}
          onViewSummary={handleViewDetailsSummary}
        />
      ),
    },
    {
      isFiltered:
        viewDraftData ||
        isActiveFilter ||
        isInactiveFilter ||
        isTotalFilter ||
        isDraftedFilter
          ? ""
          : selectedStatus,
      Header: () =>
        viewDraftData ||
        isActiveFilter ||
        isInactiveFilter ||
        isTotalFilter ||
        isDraftedFilter ? (
          <span>{t("Status")}</span>
        ) : (
          <AsyncSelect
            id="status"
            name="status"
            value={selectedStatus}
            onChange={(selectedOption) => {
              // Prevent unnecessary change if value hasn't actually changed
              if (
                selectedOption?.value === selectedStatus?.value ||
                (!selectedOption && !selectedStatus)
              ) {
                return;
              }

              setSelectedStatus(selectedOption);

              if (!selectedOption || selectedOption.value === "") {
                addFilter(
                  "status",
                  ["active", "inactive", "draft"],
                  "status",
                  false,
                  "in"
                );
              } else {
                addFilter("status", selectedOption.value);
              }
            }}
            loadOptions={(inputValue, callback) => {
              // Generate fresh options on every load with current language
              const freshOptions = [
                { value: "active", label: t("Active") },
                { value: "inactive", label: t("Inactive") },
                { value: "draft", label: t("Draft") },
              ];

              if (!inputValue) {
                callback(freshOptions);
              } else {
                const filtered = freshOptions.filter((option) =>
                  option.label.toLowerCase().includes(inputValue.toLowerCase())
                );
                callback(filtered);
              }
            }}
            defaultOptions={[
              { value: "active", label: t("Active") },
              { value: "inactive", label: t("Inactive") },
              { value: "draft", label: t("Draft") },
            ]}
            styles={getAsyncSelectStyles({
              minWidth: selectedStatus ? "160px" : "120px",
              autoWidth: true,
              fitInFlex: true,
            })}
            menuPortalTarget={document.body}
            cacheOptions
            isClearable={true}
            placeholder={t("Status")}
          />
        ),
      accessor: "personalInfo.status",
      Cell: ({ value, row }) => {
        let formattedValue = "";
        let statusClass = "";
        let dotClass = "";
        if (value === "on hold") {
          statusClass = styles.statusOnHold;
        }
        if (value === "active") {
          formattedValue = "Active";
          statusClass = styles.statusActive;
          dotClass = styles.activeDot;
        } else if (value === "inactive") {
          formattedValue = "Inactive";
          statusClass = styles.statusInactive;
          dotClass = styles.inactiveDot;
        } else if (value === "Pending" || value === "In progress") {
          statusClass = styles.statusPending;
        } else if (value === "Approved") {
          statusClass = styles.statusApproved;
        } else if (value === "Rejected") {
          statusClass = styles.statusRejected;
        } else if (value === "Completed") {
          statusClass = styles.statusCompleted;
        } else if (value === "cancelled") {
          statusClass = styles.statusCancelled;
        } else if (value === "draft") {
          statusClass = styles.draft;
          dotClass = styles.draftDot;
        } else if (value === "delete") {
          statusClass = styles.statusDelete;
          dotClass = styles.deleteDot;
        }

        return (
          <div className={statusClass}>
            <span className={dotClass}></span>
            {t(formattedValue) || t(value)}
          </div>
        );
      },
      style: {
        width: "120px",
      },
    },

    {
      Header: () => (
        <HeaderActionItem
          currentUserId={userId}
          data={data}
          isInvite={hasFilterWithValue(addedFilters, "userInvitation")}
          handleSendInvitation={handleSendInvitation}
          handleBulkStatusUpdate={handleBulkStatusUpdate}
          permissionName={"Employee"}
          statusPath="personalInfo.status"
        />
      ),
      accessor: "action",
      Cell: ({ row }) => (
        <ActionItem
          row={row.original?.personalInfo}
          rowIndex={row.index}
          handleView={handleViewProfile}
          handleEdit={handleEdit}
          isInvite={
            hasFilterWithValue(addedFilters, "userInvitation") &&
            row?.original?.personalInfo?.status === "active"
          }
          handleSendInvitation={handleSendInvitation}
          currentUser={userId === row?.original?.personalInfo?.publicId}
          handleDeactivate={handleDeactivate}
          handleDelete={handleDeactivate}
          permissionName={"Employee"}
          isDelete={true}
          isDraft={viewDraftData ? true : false}
          moduleName={t("User")}
        />
      ),
      style: {
        width: "40px",
        minWidth: "40px",
        maxWidth: "40px",
        textAlign: "center",
        padding: "10px 12px",
      },
    },
  ];

  function handleEdit(row) {
    setEditData(row);
    setAddEmployeeModal(true);
    setOpenMenu(null);
  }

  const handleSendInvitation = async (rows, isBulk) => {
    const selectedUsers = isBulk ? rows : [rows];

    const usersDetails = selectedUsers.map((r) => {
      const info = r.personalInfo || r;
      return {
        publicId: info.publicId,
        userName: info.firstName || info.userName || "",
        email: info.email || "",
      };
    });

    const details = { usersDetails };

    try {
      const response = await sendInvitation(details);
      if (response?.data) {
        notifySuccess("Invitation Sent Successfully");
        getItemsMaster();
        getNewEmployeeCount();
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    } finally {
    }
  };

  function handleDeactivate(row, isDelete) {
    if (isDelete) {
      setIsDelete(true);
      setChangeStatusTitle("Delete Employee");
      setChangeStatusMsg(
        "Are you sure you want to permanently delete this Employee? This action cannot be undone."
      );
      setChangeStatusBtn("Yes, Delete");
      setConfirmTitle("Employee Deleted Successfully!");
      setConfirmMsg("The Employee record has been permanently deleted.");
    } else if (row.status === "draft") {
      setChangeStatusTitle("Clear from Draft");
      setChangeStatusMsg(
        "Are you sure you want to clear this Employee from draft? This action will remove the draft record permanently."
      );
      setChangeStatusBtn("Yes, Clear Draft");
      setConfirmTitle("Draft Cleared Successfully!");
      setConfirmMsg("The draft employee record has been successfully removed.");
    } else if (row.status === "active") {
      setChangeStatusTitle("Deactivate Employee");
      setChangeStatusMsg(
        "Are you sure you want to deactivate this Employee? Once deactivated, the Employee will lose access to their account until reactivated."
      );
      setChangeStatusBtn("Yes, Deactivate");
      setConfirmTitle("Employee Deactivated Successfully!");
      setConfirmMsg(
        "The Employee has been deactivated. They no longer have access to their account."
      );
    } else if (!isDelete && row.status === "inactive") {
      setChangeStatusTitle("Reactivate Employee");
      setChangeStatusMsg("Are you sure you want to reactivate this Employee?");
      setChangeStatusBtn("Yes, Reactivate");
      setConfirmTitle("Employee Reactivated Successfully!");
      setConfirmMsg("The selected Employee has been reactivated.");
    }
    setDeactivateEmployeeData(row);
    setIsDeleteModalOpen(true);
  }

  const currentData = filteredData ? filteredData : data;

  const fetchEmployeesData = async () => {
    await getItemsMaster();
    setColumns(getItemsColumns());
  };

  const handleClose = () => {
    setEmpPublicId("");
    setIsOpen(false);
    setOpenMenu(null);
  };

  const handleViewProfile = (row) => {
    setEmpPublicId(row?.publicId);

    setSingleEmployeeRegistrationData(row);
    setIsOpen(true);
    setOpenMenu(null);
  };

  function onImportModal() {
    setImportEmployeeModal(true);
    setOpenMenu(null);
  }

  function closeImportModal() {
    setImportEmployeeModal(false);
    setOpenMenu(null);
  }

  function openChangeStatusModal() {
    setStatusChangeModal(true);
    setOpenMenu(null);
  }
  function closeChangeStatusModal() {
    setStatusChangeModal(false);
    setOpenMenu(null);
  }
  function openAddEmployeeModal() {
    setEditData("");
    setAddEmployeeModal(true);
    setOpenMenu(null);
  }
  function closeAddEmployeeModalWarning() {
    setChangeStatusTitle("Close Form?");
    setChangeStatusMsg("Any unsaved changes will be lost.");
    setChangeStatusBtn("Yes, Close");
    setIsDeleteModalOpen(true);
  }
  function closeAddEmployeeModal() {
    setAddEmployeeModal(false);
    setOpenMenu(null);
    setEditData("");
  }

  const handleOnSubmit = () => {
    setAddEmployeeModal(false);
    setOnSubmit(true);
    setOpenMenu(null);
  };

  const handleOnSubmitInvited = () => {
    setAddEmployeeModal(false);
    setConfirmTitle("Employee Details Saved Successfully!");
    setConfirmMsg(
      "The new employee details have been saved successfully, and the invitation has been sent. You can view or manage them in the employee list."
    );
    setSubmitConfirmTitle("");
    setSubmitConfirmMsg("");
    setSubmitConfirmBtn("");

    setDeleteConfirmModal(true);
    setOpenMenu(null);
  };

  const handleOnUpdateInvited = () => {
    setAddEmployeeModal(false);
    setConfirmTitle("Employee Details Updated Successfully!");
    setConfirmMsg(
      "The employee details have been updated successfully, and the invitation has been sent. You can view or manage them in the employee list."
    );
    setSubmitBtn("Go To Employees");
    setSubmitConfirmTitle("");
    setSubmitConfirmMsg("");
    setSubmitConfirmBtn("");

    setDeleteConfirmModal(true);
    setOpenMenu(null);
  };

  const handleDraftSubmit = () => {
    setOnDraft(true);
    setSubmitTitle("Employee Details Drafted Successfully!");
    setSubmitMsg(
      "The new employee details have been drafted successfully. You can review and complete them in the draft section."
    );
    setSubmitBtn("Go To Employees");
    setSubmitConfirmTitle("");
    setSubmitConfirmMsg("");
    setSubmitConfirmBtn("");
  };

  const handleSaveAndExitSubmit = () => {
    setOnDraft(true);
    setSubmitTitle("Employee Details Saved Successfully!");
    setSubmitMsg(
      "The new employee details have been saved successfully. You can view or manage them in the employee list."
    );
    setSubmitBtn("Go To Employees");
  };

  const handleSaveAndSubmitWhenUpdate = () => {
    setOnDraft(true);
    setSubmitTitle("Employee Details Updated Successfully!");
    setSubmitMsg("The employee details have been updated successfully.");
    setSubmitBtn("Go To Employees");
  };

  const handleOnSubmitClose = () => {
    setAddEmployeeModal(false);
    setOnSubmit(false);
    setIsFinalModal(false);
    setReactivateModal(false);
    setREactivateFinal(false);
    setOnDraft(false);
  };

  // Handler for initial delete confirmation
  const handleDeleteConfirm = () => {
    if (addEmployeeModal) {
      setAddEmployeeModal(false);
      setIsDeleteModalOpen(false);
      return;
    }

    if (bulkUpdate) {
      updateBulkStatus();
    } else {
      deactivateEmployeeMaster();
    }
  };

  const handleReactivateConfirm = () => {
    setReactivateModal(false);
    setOpenMenu(null);
    deactivateEmployeeMaster();
  };

  // Close modal methods
  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setOpenMenu(null);
  };

  const handleDeleteConfirmClose = () => {
    setDeleteConfirmModal(false);
  };

  const handleDraftClick = () => {
    const nextState = !viewDraftData;
    setViewDraftData(!viewDraftData);
    removeAllFilters();
    if (nextState) {
      addFilter("status", ["draft"], "status", false, "in");
    } else {
      addFilter(
        "status",
        ["active", "inactive", "draft"],
        "status",
        false,
        "in"
      );
    }
  };
  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleItemsPerPageChange = (totalItems) => {
    setItemsPerPage(totalItems);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className={stylesMain.footerHelper}>
          <div className="content">
            <div className="content-container">
              <TableComponent
                loading={isLoading}
                searchTerm={searchTerm}
                handleSearchTermDebounce={handleSearchTermDebounce}
                additionalStats={!viewDraftData && additionalStats}
                handleAdditionalStatsClick={handleAdditionalStatsClick}
                exportLoading={exportLoading}
                handleExportClick={handleExportClick}
                headerDescription={t(
                  "Easily add, update, or remove employees from here. Manage employee details and ensure smooth workforce operations."
                )}
                handleCloseMenu={handleCloseMenu}
                dropdownRef={dropdownRef}
                threeDotsRef={threeDotsRef}
                totalCount={totalCount}
                draftCount={draftCount}
                headerTitle={t("employeeModule.Employees")}
                headerPrimaryBtnName={
                  grantPermission("Employee:write") ? t("New Employee") : null
                }
                headerPrimaryBtnClick={openAddEmployeeModal}
                headerSecondaryBtnName={
                  grantPermission("Employee:write")
                    ? t("Import Employee")
                    : null
                }
                headerSecondaryBtnClick={onImportModal}
                columns={columns}
                data={currentData}
                isRead={grantPermission("Employee:read")}
                isTable={grantPermission("Employee:read")}
                draftBtn={true}
                onClickDraft={handleDraftClick}
                draftView={viewDraftData}
                allEmpCount={allEmpCount}
                noData={noData}
              />
            </div>
          </div>
          {grantPermission("Employee:read") && !isLoading && (
            <Pagination
              itemsPerPage={itemsPerPage}
              handleItemsPerPageChange={handleItemsPerPageChange}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          )}
        </div>

        {/* <div className="content">
          <div className="modals-navigation">
            <span className="modal-option" onClick={onImportModal}>
              Import Employee
            </span>
            <span className="modal-option" onClick={openChangeStatusModal}>
              Change Status To Inactive
            </span>
            <span className="modal-option" onClick={openAddEmployeeModal}>
              Add New Employee
            </span>
          </div>
        </div> */}
      </div>
      {importEmployeeModal && (
        <ImportEmployeeModal
          isOpen={importEmployeeModal}
          onClose={closeImportModal}
          getTableData={getItemsMaster}
          getAdditionalCounts={getNewEmployeeCount}
        />
      )}

      {statusChangeModal && (
        <ChangeStatusModal
          isOpen={statusChangeModal}
          onClose={closeChangeStatusModal}
        />
      )}

      {addEmployeeModal && (
        <AddEmployeeModal
          handleOnSubmit={handleOnSubmit}
          handleOnSubmitInvited={handleOnSubmitInvited}
          handleOnUpdateInvited={handleOnUpdateInvited}
          isOpen={addEmployeeModal}
          onClose={closeAddEmployeeModal}
          onCloseWarning={closeAddEmployeeModalWarning}
          empPublicId={editData?.publicId}
          invitePending={editData?.userInvitation === "false"}
          handleGetTableData={getItemsMaster}
          handleDraftSubmit={handleDraftSubmit}
          handleSaveSubmit={handleSaveAndExitSubmit}
          handleSaveAndSubmitWhenUpdate={handleSaveAndSubmitWhenUpdate}
          getEmployeeStats={getNewEmployeeCount}
          getAdditionalStats={getNewEmployeeCount}
          currentEmployeeEditing={userId === editData?.publicId}
        />
      )}

      {isOpen && (
        <EmployeeModal
          isOpen={isOpen}
          onClose={handleClose}
          empPublicId={empPublicId}
          employeeGeneralInfo={singleEmployeeRegistrationData}
          handleGetTableData={getItemsMaster}
        />
      )}
      {onSubmit && (
        <DeleteConfirmationModal
          icon={<Tick />}
          isOpen={onSubmit}
          // headline={t(
          //   `Employee ${editData ? "Updated" : "Added"} Successfully!`
          // )}
          headline={
            editData
              ? t("Employee Updated Successfully!")
              : t("Employee Added Successfully!")
          }
          paraText={
            editData
              ? t("The Employee has been updated successfully!")
              : t(`The new employee has been added.`)
          }
          confirmText={t("Go To Employees")}
          isConfirm={true}
          onConfirm={handleOnSubmitClose}
          onCancel={handleOnSubmitClose}
          onClose={handleOnSubmitClose}
        />
      )}

      {onDraft && (
        <DeleteConfirmationModal
          icon={<Tick />}
          isOpen={onDraft}
          headline={submitTitle}
          paraText={submitMsg}
          confirmText={submitBtn}
          isConfirm={true}
          onConfirm={handleOnSubmitClose}
          onCancel={handleOnSubmitClose}
          onClose={handleOnSubmitClose}
        />
      )}
      {isDeleteModalOpen && (
        <DeleteModal
          icon={<ExclaimRed />}
          isOpen={isDeleteModalOpen}
          headline={changeStatusTitle}
          headlineData={changeStatusTitleData}
          paraText={changeStatusMsg}
          paraTextData={changeStatusMsgData}
          buttonText="cancel"
          confirmText={changeStatusBtn}
          isDelete={true}
          onConfirm={handleDeleteConfirm}
          onCancel={handleCloseDeleteModal}
          onClose={handleCloseDeleteModal}
        />
      )}
      {deleteConfirmModal && (
        <DeleteConfirmationModal
          icon={<Tick />}
          isOpen={deleteConfirmModal}
          headline={confirmTitle}
          headlineData={confirmTitleData}
          paraText={confirmMsg}
          paraTextData={confirmMsgData}
          confirmText="Go To Employees"
          isConfirm={true}
          onConfirm={handleDeleteConfirmClose}
          onCancel={handleDeleteConfirmClose}
          onClose={handleDeleteConfirmClose}
        />
      )}

      {isFinalModal && (
        <DeleteConfirmationModal
          icon={<Tick />}
          isOpen={isFinalModal}
          headline="Employee Deactivated Successfully!"
          paraText={`The selected Employee has been removed from the system.`}
          confirmText="Go To Employees"
          isConfirm={true}
          onConfirm={handleOnSubmitClose}
          onCancel={handleOnSubmitClose}
          onClose={handleOnSubmitClose}
        />
      )}

      {reactivateModal && (
        <DeleteModal
          icon={<ExclaimRed />}
          isOpen={reactivateModal}
          headline="Reactivate Employee"
          paraText="Are you sure you want to reactivate this Employee?"
          buttonText="Cancel"
          confirmText="Yes, Continue"
          isDelete={true}
          onConfirm={handleReactivateConfirm}
          onCancel={handleReactivateConfirm}
          onClose={handleReactivateConfirm}
        />
      )}

      {reactivateFinal && (
        <DeleteConfirmationModal
          icon={<Tick />}
          isOpen={reactivateFinal}
          headline="Employee Reactivated Successfully!"
          paraText={`The selected Employee has been Reactivate.`}
          confirmText="Go To Employees"
          isConfirm={true}
          onConfirm={handleOnSubmitClose}
          onCancel={handleOnSubmitClose}
          onClose={handleOnSubmitClose}
        />
      )}
      {empDetailsSummaryModal && (
        <EmployeeRegistrationSummaryModal
          isOpen={empDetailsSummaryModal}
          onClose={() => setEmpDetailsSummaryModal(false)}
          detailsSummaryPublicId={detailsSummaryPublicId}
          handleViewProfile={handleViewProfile}
          handleEdit={handleEdit}
        />
      )}
    </>
  );
}
